import React ,{useEffect,useState,useContext } from 'react'
 
import axios from 'axios';
import {  useForm } from "react-hook-form";
import { Col, Row, Form, Button  } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import './portfolio.css';
import Sidebar from '../Home/Sidebar';
import Loader from '../Loader/Loader';
import Variables from "../../constants/Variables";
import { AuthContext } from "../../contexts/AuthProvider";
import { toast } from 'react-hot-toast';

const Addportfolio = ( props) => {
    let {id} = useParams();
    const [data, setData] = useState();
    const [portfolios, setPortfolios] = useState('');
    const [project, setProject] = useState('');
    const [techstacks, setTechstacks] = useState('');
    const [newTechStacks, setNewTechstacks] = useState('');
    const techStacks = Variables.techStacks;
    const { user } = useContext(AuthContext);
    
    const { register } = useForm();
    useEffect(() => {
      // console.log(id,"hello ");
      const fetchCompanyData = async ( ) => {
         
        try {
          const response = await fetch('https://apichatgptresponse.managedcoder.com/api/techstack/getAllTechstacks/'+user.email);
          const responsedata = await response.json();
          // console.log(responsedata);
          // setData(responsedata)
          // setPortfolios(response);
          var index
          var TechStackDropDown = []
          responsedata.map((portfolio)=>{
              // console.log('array is', portfolio.tech_stack)
              index = techStacks.indexOf(portfolio.tech_stack);
                if (index > -1) { // only splice array when item is found
                  techStacks.splice(index, 1); // 2nd parameter means remove one item only
                }
          })
          setProject(responsedata.projects);
          // console.log(response)
          setNewTechstacks(responsedata)
          // setTechstacks(responsedata.tech_stack)
          // console.log(techstacks)
        } catch (error) {
          console.error(error);
        }
      }
      fetchCompanyData();
    
    }, []);
   
        let projects = project
        let portfolio =  portfolios
        let techstack =  techstacks
        const navigate = useNavigate();
      const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(projects);
        // console.log(portfolio);
        // console.log(techstack);
      const payload = {
            "useremail" : user.email,
            "techstack" : techstack,
            "portfolio" : portfolio,
            "project" : projects
        }
        fetch(`https://apichatgptresponse.managedcoder.com/api/techstack/addPortfolio/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((data) => {
            // console.log("Success:", data);
            toast.success('Portfolio Added Successfully');
            navigate('/portfolio');
          })
          .catch((error) => {
            // console.error("Error:", error);
            toast.error('Failed to add Portfolio');
          });
         
      };
      var TechStackArray = []
      // newTechStacks.map((portfolio) => {
      //   if(!techStacks.includes(portfolio.tech_stack)){
      //     TechStackArray = portfolio.tech_stack
      //   }
      // })
  return (
     <>
      <div className="row">
        <div className="col-3">
          <Sidebar />
        </div>
        <div className="col-9">
          <div className='article-title'>
              <Row>
              <div className="mb-3">
                <h3 className="title">Add Portfolio</h3>
              </div>
                  <Col md="9">
                      <Form onSubmit={handleSubmit}>
                          <Row>
                              <Col>
                                {
                                  <>
                                    <Form.Group className="mb-4" >
                                    <Form.Group className="mb-4">
                                    <Form.Label className="portfolio-header">Tech Stack*</Form.Label>
                                        <Form.Select aria-label="Default select example" onChange={(e) => setTechstacks(e.target.value)} value={techstack}>
                                        <option>Select The Tech Stack</option>
                                        {techStacks.map((item, index) => (
                                            <option key={index} value={item}>{item}</option>
                                        ))}
                                        </Form.Select>
                                    </Form.Group>

                                      <Form.Label className="portfolio-header">Portfolio </Form.Label>                                   


                                      <Form.Control 
                                      
                                        type="text"
                                        placeholder="Portfolio"
                                        {...register("portfolio", { required: false })}
                                        value={portfolios}
                                        onChange={(e) => setPortfolios(e.target.value)}
                                      />
                                      <br/> 
                                        <Form.Label className="project-header">Projects </Form.Label>  
                                          
                                        <Form.Control 
                                        
                                        as="textarea"
                                        placeholder="Projects"
                                        rows={6}
                                        {...register("projects", { required: false })}
                                        value={project}
                                        onChange={(e) => setProject(e.target.value)}
                                      />
                                      <br/>   
                                      <div className='text-end'>
                                        <Button className='update-btn' type="submit">Submit</Button> 
                                        </div>                                       
                                      </Form.Group>
                                    </>
                                }                                     
                              </Col>
                          </Row>
                      </Form>
                  </Col>
              </Row>
          </div>
        </div>
        </div>
    </>
  )
}

export default Addportfolio;
